(function () {
  if (window.__lovShippingProgressLoaded) return;
  window.__lovShippingProgressLoaded = true;

  function parseList(value) {
    return String(value || '')
      .split(',')
      .map(function (item) {
        return item.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    var activeCurrency =
      currency ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: activeCurrency
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function isExcludedItem(item, block) {
    var excludedHandles = parseList(block.getAttribute('data-excluded-handles'));
    var excludedProductTypes = parseList(block.getAttribute('data-excluded-product-types'));
    var excludedVendors = parseList(block.getAttribute('data-excluded-vendors'));

    var itemHandle = String(item.handle || '').toLowerCase();
    var itemProductType = String(item.product_type || '').toLowerCase();
    var itemVendor = String(item.vendor || '').toLowerCase();

    if (itemHandle && excludedHandles.indexOf(itemHandle) !== -1) return true;
    if (itemProductType && excludedProductTypes.indexOf(itemProductType) !== -1) return true;
    if (itemVendor && excludedVendors.indexOf(itemVendor) !== -1) return true;

    return false;
  }

  function getEligibleCartSummary(cart, block) {
    var summary = {
      subtotal: 0,
      eligibleItemCount: 0,
      excludedItemCount: 0,
      totalItemCount: 0
    };

    if (!cart || !cart.items || !cart.items.length) return summary;

    cart.items.forEach(function (item) {
      var quantity = Number(item.quantity || 0);
      summary.totalItemCount += quantity;

      if (isExcludedItem(item, block)) {
        summary.excludedItemCount += quantity;
        return;
      }

      summary.eligibleItemCount += quantity;

      summary.subtotal += Number(
        item.final_line_price != null
          ? item.final_line_price
          : item.line_price != null
            ? item.line_price
            : 0
      );
    });

    return summary;
  }

  function updateShippingProgress(cart) {
    var blocks = document.querySelectorAll('[data-lv-shipping-progress]');
    if (!blocks.length || !cart) return;

    blocks.forEach(function (block) {
      var threshold = Number(block.getAttribute('data-threshold') || 0);
      var currency = block.getAttribute('data-currency') || cart.currency || 'USD';
      var prefix = block.getAttribute('data-prefix') || 'Add';
      var suffix = block.getAttribute('data-suffix') || 'more to unlock free shipping.';
      var unlocked = block.getAttribute('data-unlocked') || 'Free shipping unlocked.';
      var hideWhenNoEligible = block.getAttribute('data-hide-when-no-eligible') === 'true';

      if (!threshold) return;

      var summary = getEligibleCartSummary(cart, block);
      var eligibleSubtotal = summary.subtotal;

      if (
        hideWhenNoEligible &&
        summary.totalItemCount > 0 &&
        summary.eligibleItemCount === 0
      ) {
        block.hidden = true;
        return;
      }

      block.hidden = false;

      var remaining = threshold - eligibleSubtotal;
      var progress = Math.round((eligibleSubtotal / threshold) * 100);

      if (progress > 100) progress = 100;
      if (progress < 0) progress = 0;

      block.style.setProperty('--lv-shipping-progress', progress + '%');

      var currentEl = block.querySelector('[data-lv-shipping-current]');
      var thresholdEl = block.querySelector('[data-lv-shipping-threshold]');
      var remainingEl = block.querySelector('[data-lv-shipping-remaining]');
      var messageEl = block.querySelector('[data-lv-shipping-message]');

      if (currentEl) currentEl.textContent = formatMoney(eligibleSubtotal, currency);
      if (thresholdEl) thresholdEl.textContent = formatMoney(threshold, currency);

      if (messageEl) {
        if (remaining > 0) {
          messageEl.innerHTML =
            prefix +
            ' <strong data-lv-shipping-remaining>' +
            formatMoney(remaining, currency) +
            '</strong> ' +
            suffix;
        } else {
          messageEl.textContent = unlocked;
        }
      } else if (remainingEl) {
        remainingEl.textContent = formatMoney(Math.max(remaining, 0), currency);
      }
    });
  }

  function refreshShippingProgress() {
    fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateShippingProgress(cart);
      })
      .catch(function () {});
  }

  var originalFetch = window.fetch;

  if (originalFetch && !window.__lovShippingProgressFetchPatched) {
    window.__lovShippingProgressFetchPatched = true;

    window.fetch = function () {
      var args = arguments;
      var url = '';

      try {
        url = typeof args[0] === 'string' ? args[0] : args[0].url;
      } catch (e) {}

      return originalFetch.apply(this, args).then(function (response) {
        if (
          url &&
          (
            url.indexOf('/cart/add') !== -1 ||
            url.indexOf('/cart/change') !== -1 ||
            url.indexOf('/cart/update') !== -1 ||
            url.indexOf('/cart/clear') !== -1
          )
        ) {
          setTimeout(refreshShippingProgress, 150);
          setTimeout(refreshShippingProgress, 700);
        }

        return response;
      });
    };
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action) return;

    if (form.action.indexOf('/cart/add') !== -1) {
      setTimeout(refreshShippingProgress, 250);
      setTimeout(refreshShippingProgress, 900);
    }
  });

  document.addEventListener('cart:updated', refreshShippingProgress);
  document.addEventListener('DOMContentLoaded', refreshShippingProgress);

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    refreshShippingProgress();
  }
})();